const RECURLY_SCRIPT_SOURCE = 'https://js.recurly.com/v4/recurly.js';

export default RECURLY_SCRIPT_SOURCE;
